import React from 'react';
import AdminAuditionSlider from '../AdminAuditionLiveSlider/AdminAuditionSlider';
import AdminAuditionNav from '../AdminAuditionNav/AdminAuditionNav';
import liveAuditionIcon from '../../../../../../assets/images/liveAudition.png'

const AdminAuditionLive = () => {
return (
<>
    <AdminAuditionNav />

    <div className="card card-bg head-line mt-4 mb-2 mt-4 mb-2">
        <div className="text-light d-flex p-2">
            <div className="faTrophy">
                <img src={liveAuditionIcon} alt="" />
            </div>
            <h4 className="mx-3 text-white p-2">Live Auditions</h4>
        </div>
    </div>

    {/*
    <PendingAuditionSlider /> */}
    <AdminAuditionSlider />

</>
);
};

export default AdminAuditionLive;
